
import Table from "./Table"
import { useEffect, useState} from "react";


function TableSelection({year, demographics, movement}) {
    const [Data, setData] = useState([])
    
    var url = ""
    if(movement.length === 0){
      url = '/api/infoforcharacteristic/'+ year + '/' + demographics;
    }
    else {
      url = '/api/infoformovement/'+ year + '/' + movement;
    }
    
    useEffect(() => {

        fetch(url).then((res) =>
            res.json().then((res) => {
                 console.log(res)
               
                setData(res.data.Info)

          })
        )
        .catch((error) => {
          console.log("Refetching data!")
        });
      }, [url]);
    
    
    if(Data.length !== 0){
      return (
        
          <Table data = {Data}></Table>
        );
    }
    else {
      return <></>
    }

    };

export default TableSelection;

